/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DateTimeRangeSchema,
  FeatureCollection,
  GridJobConfigSchemaInput,
  GridJobConfigSchemaOutput,
  GridJobInstanceSchema,
  HTTPValidationError,
  LssConsumerMetricsSchema,
  PageGridJobConfigSchema,
  PageGridJobInstanceSchema,
  PageStatVoyPosReportSchema,
  StatVoyPosReportSchemaInput,
  StatVoyPosReportSchemaOutput,
} from '../models';
import {
    DateTimeRangeSchemaFromJSON,
    DateTimeRangeSchemaToJSON,
    FeatureCollectionFromJSON,
    FeatureCollectionToJSON,
    GridJobConfigSchemaInputFromJSON,
    GridJobConfigSchemaInputToJSON,
    GridJobConfigSchemaOutputFromJSON,
    GridJobConfigSchemaOutputToJSON,
    GridJobInstanceSchemaFromJSON,
    GridJobInstanceSchemaToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    LssConsumerMetricsSchemaFromJSON,
    LssConsumerMetricsSchemaToJSON,
    PageGridJobConfigSchemaFromJSON,
    PageGridJobConfigSchemaToJSON,
    PageGridJobInstanceSchemaFromJSON,
    PageGridJobInstanceSchemaToJSON,
    PageStatVoyPosReportSchemaFromJSON,
    PageStatVoyPosReportSchemaToJSON,
    StatVoyPosReportSchemaInputFromJSON,
    StatVoyPosReportSchemaInputToJSON,
    StatVoyPosReportSchemaOutputFromJSON,
    StatVoyPosReportSchemaOutputToJSON,
} from '../models';

export interface CreateGridJobConfigGridJobConfigsPostRequest {
    gridJobConfigSchemaInput: GridJobConfigSchemaInput;
}

export interface CreateGridJobInstanceConfigGridJobConfigsJobIdInstancesPostRequest {
    jobId: any;
    gridJobInstanceSchema: GridJobInstanceSchema;
}

export interface CreateLssConsumerMetricPointLssConsumerMetricsPostRequest {
    lssConsumerMetricsSchema: LssConsumerMetricsSchema;
}

export interface CreateStatVoyPosReportStatVoyPosReportsPostRequest {
    body: any | null;
}

export interface DeleteGridJobConfigGridJobConfigsJobIdDeleteRequest {
    jobId: any;
}

export interface DeleteGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdDeleteRequest {
    jobId: any;
    jobInstanceId: any;
}

export interface DeleteStatVoyPosReportStatVoyPosReportsIdDeleteRequest {
    id: any;
}

export interface GetGridJobConfigGridJobConfigsJobIdGetRequest {
    jobId: any;
}

export interface GetGridJobConfigGridJobConfigsJobIdHexagongridGetRequest {
    jobId: any;
}

export interface GetGridJobConfigsGridJobConfigsGetRequest {
    page?: any;
    size?: any;
}

export interface GetGridJobInstanceGridJobConfigsJobIdInstancesJobInstanceIdGetRequest {
    jobId: any;
    jobInstanceId: any;
}

export interface GetGridJobInstancesGridJobConfigsJobIdInstancesGetRequest {
    jobId: any;
    page?: any;
    size?: any;
}

export interface GetGridJobResultsGridJobResultsJobIdResultsGetRequest {
    jobId: any;
    startTime?: any;
    endTime?: any;
}

export interface GetGridJobResultsGridJobResultsJobIdResultsJobInstanceIdGetRequest {
    jobId: any;
    jobInstanceId: any;
}

export interface GetGridJobTracksGridJobResultsJobIdTracksJobInstanceIdGetRequest {
    jobId: any;
    jobInstanceId: any;
    mmsi?: any;
}

export interface GetStatVoyPosReportStatVoyPosReportsIdGetRequest {
    id: any;
}

export interface GetStatVoyPosReportsStatVoyPosReportsGetRequest {
    page?: any;
    size?: any;
}

export interface UpdateGridJobConfigGridJobConfigsJobIdPutRequest {
    jobId: any;
    gridJobConfigSchemaInput: GridJobConfigSchemaInput;
}

export interface UpdateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPutRequest {
    jobId: any;
    jobInstanceId: any;
    gridJobInstanceSchema: GridJobInstanceSchema;
}

export interface UpdateStatVoyPosReportStatVoyPosReportsIdPutRequest {
    id: any;
    statVoyPosReportSchemaInput: StatVoyPosReportSchemaInput;
}

/**
 * 
 */
export class GpsLostApi extends runtime.BaseAPI {

    /**
     * Create Grid Job Config
     */
    async createGridJobConfigGridJobConfigsPostRaw(requestParameters: CreateGridJobConfigGridJobConfigsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GridJobConfigSchemaOutput>> {
        if (requestParameters.gridJobConfigSchemaInput === null || requestParameters.gridJobConfigSchemaInput === undefined) {
            throw new runtime.RequiredError('gridJobConfigSchemaInput','Required parameter requestParameters.gridJobConfigSchemaInput was null or undefined when calling createGridJobConfigGridJobConfigsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GridJobConfigSchemaInputToJSON(requestParameters.gridJobConfigSchemaInput),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GridJobConfigSchemaOutputFromJSON(jsonValue));
    }

    /**
     * Create Grid Job Config
     */
    async createGridJobConfigGridJobConfigsPost(requestParameters: CreateGridJobConfigGridJobConfigsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GridJobConfigSchemaOutput> {
        const response = await this.createGridJobConfigGridJobConfigsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Grid Job Instance Config
     */
    async createGridJobInstanceConfigGridJobConfigsJobIdInstancesPostRaw(requestParameters: CreateGridJobInstanceConfigGridJobConfigsJobIdInstancesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GridJobInstanceSchema>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling createGridJobInstanceConfigGridJobConfigsJobIdInstancesPost.');
        }

        if (requestParameters.gridJobInstanceSchema === null || requestParameters.gridJobInstanceSchema === undefined) {
            throw new runtime.RequiredError('gridJobInstanceSchema','Required parameter requestParameters.gridJobInstanceSchema was null or undefined when calling createGridJobInstanceConfigGridJobConfigsJobIdInstancesPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}/instances`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GridJobInstanceSchemaToJSON(requestParameters.gridJobInstanceSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GridJobInstanceSchemaFromJSON(jsonValue));
    }

    /**
     * Create Grid Job Instance Config
     */
    async createGridJobInstanceConfigGridJobConfigsJobIdInstancesPost(requestParameters: CreateGridJobInstanceConfigGridJobConfigsJobIdInstancesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GridJobInstanceSchema> {
        const response = await this.createGridJobInstanceConfigGridJobConfigsJobIdInstancesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Lss Consumer Metric Point
     */
    async createLssConsumerMetricPointLssConsumerMetricsPostRaw(requestParameters: CreateLssConsumerMetricPointLssConsumerMetricsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LssConsumerMetricsSchema>> {
        if (requestParameters.lssConsumerMetricsSchema === null || requestParameters.lssConsumerMetricsSchema === undefined) {
            throw new runtime.RequiredError('lssConsumerMetricsSchema','Required parameter requestParameters.lssConsumerMetricsSchema was null or undefined when calling createLssConsumerMetricPointLssConsumerMetricsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/lss-consumer-metrics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LssConsumerMetricsSchemaToJSON(requestParameters.lssConsumerMetricsSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LssConsumerMetricsSchemaFromJSON(jsonValue));
    }

    /**
     * Create Lss Consumer Metric Point
     */
    async createLssConsumerMetricPointLssConsumerMetricsPost(requestParameters: CreateLssConsumerMetricPointLssConsumerMetricsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LssConsumerMetricsSchema> {
        const response = await this.createLssConsumerMetricPointLssConsumerMetricsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Stat Voy Pos Report
     */
    async createStatVoyPosReportStatVoyPosReportsPostRaw(requestParameters: CreateStatVoyPosReportStatVoyPosReportsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling createStatVoyPosReportStatVoyPosReportsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/stat-voy-pos-reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create Stat Voy Pos Report
     */
    async createStatVoyPosReportStatVoyPosReportsPost(requestParameters: CreateStatVoyPosReportStatVoyPosReportsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createStatVoyPosReportStatVoyPosReportsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Grid Job Config
     */
    async deleteGridJobConfigGridJobConfigsJobIdDeleteRaw(requestParameters: DeleteGridJobConfigGridJobConfigsJobIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling deleteGridJobConfigGridJobConfigsJobIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Grid Job Config
     */
    async deleteGridJobConfigGridJobConfigsJobIdDelete(requestParameters: DeleteGridJobConfigGridJobConfigsJobIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGridJobConfigGridJobConfigsJobIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete Grid Job Instances
     */
    async deleteGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdDeleteRaw(requestParameters: DeleteGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling deleteGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdDelete.');
        }

        if (requestParameters.jobInstanceId === null || requestParameters.jobInstanceId === undefined) {
            throw new runtime.RequiredError('jobInstanceId','Required parameter requestParameters.jobInstanceId was null or undefined when calling deleteGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}/instances/{job_instance_id}`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))).replace(`{${"job_instance_id"}}`, encodeURIComponent(String(requestParameters.jobInstanceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Grid Job Instances
     */
    async deleteGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdDelete(requestParameters: DeleteGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete Stat Voy Pos Report
     */
    async deleteStatVoyPosReportStatVoyPosReportsIdDeleteRaw(requestParameters: DeleteStatVoyPosReportStatVoyPosReportsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteStatVoyPosReportStatVoyPosReportsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/stat-voy-pos-reports/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Stat Voy Pos Report
     */
    async deleteStatVoyPosReportStatVoyPosReportsIdDelete(requestParameters: DeleteStatVoyPosReportStatVoyPosReportsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStatVoyPosReportStatVoyPosReportsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get Grid Job Config
     */
    async getGridJobConfigGridJobConfigsJobIdGetRaw(requestParameters: GetGridJobConfigGridJobConfigsJobIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GridJobConfigSchemaOutput>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getGridJobConfigGridJobConfigsJobIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GridJobConfigSchemaOutputFromJSON(jsonValue));
    }

    /**
     * Get Grid Job Config
     */
    async getGridJobConfigGridJobConfigsJobIdGet(requestParameters: GetGridJobConfigGridJobConfigsJobIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GridJobConfigSchemaOutput> {
        const response = await this.getGridJobConfigGridJobConfigsJobIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Grid Job Config
     */
    async getGridJobConfigGridJobConfigsJobIdHexagongridGetRaw(requestParameters: GetGridJobConfigGridJobConfigsJobIdHexagongridGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeatureCollection>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getGridJobConfigGridJobConfigsJobIdHexagongridGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}/hexagongrid`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FeatureCollectionFromJSON(jsonValue));
    }

    /**
     * Get Grid Job Config
     */
    async getGridJobConfigGridJobConfigsJobIdHexagongridGet(requestParameters: GetGridJobConfigGridJobConfigsJobIdHexagongridGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureCollection> {
        const response = await this.getGridJobConfigGridJobConfigsJobIdHexagongridGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Grid Job Configs
     */
    async getGridJobConfigsGridJobConfigsGetRaw(requestParameters: GetGridJobConfigsGridJobConfigsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageGridJobConfigSchema>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageGridJobConfigSchemaFromJSON(jsonValue));
    }

    /**
     * Get Grid Job Configs
     */
    async getGridJobConfigsGridJobConfigsGet(requestParameters: GetGridJobConfigsGridJobConfigsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageGridJobConfigSchema> {
        const response = await this.getGridJobConfigsGridJobConfigsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Grid Job Instance
     */
    async getGridJobInstanceGridJobConfigsJobIdInstancesJobInstanceIdGetRaw(requestParameters: GetGridJobInstanceGridJobConfigsJobIdInstancesJobInstanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GridJobInstanceSchema>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getGridJobInstanceGridJobConfigsJobIdInstancesJobInstanceIdGet.');
        }

        if (requestParameters.jobInstanceId === null || requestParameters.jobInstanceId === undefined) {
            throw new runtime.RequiredError('jobInstanceId','Required parameter requestParameters.jobInstanceId was null or undefined when calling getGridJobInstanceGridJobConfigsJobIdInstancesJobInstanceIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}/instances/{job_instance_id}`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))).replace(`{${"job_instance_id"}}`, encodeURIComponent(String(requestParameters.jobInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GridJobInstanceSchemaFromJSON(jsonValue));
    }

    /**
     * Get Grid Job Instance
     */
    async getGridJobInstanceGridJobConfigsJobIdInstancesJobInstanceIdGet(requestParameters: GetGridJobInstanceGridJobConfigsJobIdInstancesJobInstanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GridJobInstanceSchema> {
        const response = await this.getGridJobInstanceGridJobConfigsJobIdInstancesJobInstanceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Grid Job Instances
     */
    async getGridJobInstancesGridJobConfigsJobIdInstancesGetRaw(requestParameters: GetGridJobInstancesGridJobConfigsJobIdInstancesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageGridJobInstanceSchema>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getGridJobInstancesGridJobConfigsJobIdInstancesGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}/instances`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageGridJobInstanceSchemaFromJSON(jsonValue));
    }

    /**
     * Get Grid Job Instances
     */
    async getGridJobInstancesGridJobConfigsJobIdInstancesGet(requestParameters: GetGridJobInstancesGridJobConfigsJobIdInstancesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageGridJobInstanceSchema> {
        const response = await this.getGridJobInstancesGridJobConfigsJobIdInstancesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Grid Job Results
     */
    async getGridJobResultsGridJobResultsJobIdResultsGetRaw(requestParameters: GetGridJobResultsGridJobResultsJobIdResultsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getGridJobResultsGridJobResultsJobIdResultsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.startTime !== undefined) {
            queryParameters['start_time'] = requestParameters.startTime;
        }

        if (requestParameters.endTime !== undefined) {
            queryParameters['end_time'] = requestParameters.endTime;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-results/{job_id}/results`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get Grid Job Results
     */
    async getGridJobResultsGridJobResultsJobIdResultsGet(requestParameters: GetGridJobResultsGridJobResultsJobIdResultsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getGridJobResultsGridJobResultsJobIdResultsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Grid Job Results
     */
    async getGridJobResultsGridJobResultsJobIdResultsJobInstanceIdGetRaw(requestParameters: GetGridJobResultsGridJobResultsJobIdResultsJobInstanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getGridJobResultsGridJobResultsJobIdResultsJobInstanceIdGet.');
        }

        if (requestParameters.jobInstanceId === null || requestParameters.jobInstanceId === undefined) {
            throw new runtime.RequiredError('jobInstanceId','Required parameter requestParameters.jobInstanceId was null or undefined when calling getGridJobResultsGridJobResultsJobIdResultsJobInstanceIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-results/{job_id}/results/{job_instance_id}`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))).replace(`{${"job_instance_id"}}`, encodeURIComponent(String(requestParameters.jobInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get Grid Job Results
     */
    async getGridJobResultsGridJobResultsJobIdResultsJobInstanceIdGet(requestParameters: GetGridJobResultsGridJobResultsJobIdResultsJobInstanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getGridJobResultsGridJobResultsJobIdResultsJobInstanceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Grid Job Tracks
     */
    async getGridJobTracksGridJobResultsJobIdTracksJobInstanceIdGetRaw(requestParameters: GetGridJobTracksGridJobResultsJobIdTracksJobInstanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getGridJobTracksGridJobResultsJobIdTracksJobInstanceIdGet.');
        }

        if (requestParameters.jobInstanceId === null || requestParameters.jobInstanceId === undefined) {
            throw new runtime.RequiredError('jobInstanceId','Required parameter requestParameters.jobInstanceId was null or undefined when calling getGridJobTracksGridJobResultsJobIdTracksJobInstanceIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.mmsi !== undefined) {
            queryParameters['mmsi'] = requestParameters.mmsi;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-results/{job_id}/tracks/{job_instance_id}`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))).replace(`{${"job_instance_id"}}`, encodeURIComponent(String(requestParameters.jobInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get Grid Job Tracks
     */
    async getGridJobTracksGridJobResultsJobIdTracksJobInstanceIdGet(requestParameters: GetGridJobTracksGridJobResultsJobIdTracksJobInstanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getGridJobTracksGridJobResultsJobIdTracksJobInstanceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Stat Voy Pos Report
     */
    async getStatVoyPosReportStatVoyPosReportsIdGetRaw(requestParameters: GetStatVoyPosReportStatVoyPosReportsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatVoyPosReportSchemaOutput>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getStatVoyPosReportStatVoyPosReportsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/stat-voy-pos-reports/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatVoyPosReportSchemaOutputFromJSON(jsonValue));
    }

    /**
     * Get Stat Voy Pos Report
     */
    async getStatVoyPosReportStatVoyPosReportsIdGet(requestParameters: GetStatVoyPosReportStatVoyPosReportsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatVoyPosReportSchemaOutput> {
        const response = await this.getStatVoyPosReportStatVoyPosReportsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Daterange Of Stat Voy Post Date
     */
    async getStatVoyPosReportsDaterangeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DateTimeRangeSchema>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/stat-voy-pos-reports/daterange`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DateTimeRangeSchemaFromJSON(jsonValue));
    }

    /**
     * Get Daterange Of Stat Voy Post Date
     */
    async getStatVoyPosReportsDaterange(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DateTimeRangeSchema> {
        const response = await this.getStatVoyPosReportsDaterangeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Stat Voy Pos Reports
     */
    async getStatVoyPosReportsStatVoyPosReportsGetRaw(requestParameters: GetStatVoyPosReportsStatVoyPosReportsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageStatVoyPosReportSchema>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/stat-voy-pos-reports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageStatVoyPosReportSchemaFromJSON(jsonValue));
    }

    /**
     * Get Stat Voy Pos Reports
     */
    async getStatVoyPosReportsStatVoyPosReportsGet(requestParameters: GetStatVoyPosReportsStatVoyPosReportsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageStatVoyPosReportSchema> {
        const response = await this.getStatVoyPosReportsStatVoyPosReportsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Grid Job Config
     */
    async updateGridJobConfigGridJobConfigsJobIdPutRaw(requestParameters: UpdateGridJobConfigGridJobConfigsJobIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GridJobConfigSchemaOutput>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling updateGridJobConfigGridJobConfigsJobIdPut.');
        }

        if (requestParameters.gridJobConfigSchemaInput === null || requestParameters.gridJobConfigSchemaInput === undefined) {
            throw new runtime.RequiredError('gridJobConfigSchemaInput','Required parameter requestParameters.gridJobConfigSchemaInput was null or undefined when calling updateGridJobConfigGridJobConfigsJobIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GridJobConfigSchemaInputToJSON(requestParameters.gridJobConfigSchemaInput),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GridJobConfigSchemaOutputFromJSON(jsonValue));
    }

    /**
     * Update Grid Job Config
     */
    async updateGridJobConfigGridJobConfigsJobIdPut(requestParameters: UpdateGridJobConfigGridJobConfigsJobIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GridJobConfigSchemaOutput> {
        const response = await this.updateGridJobConfigGridJobConfigsJobIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Grid Job Instances
     */
    async updateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPutRaw(requestParameters: UpdateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GridJobInstanceSchema>> {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling updateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPut.');
        }

        if (requestParameters.jobInstanceId === null || requestParameters.jobInstanceId === undefined) {
            throw new runtime.RequiredError('jobInstanceId','Required parameter requestParameters.jobInstanceId was null or undefined when calling updateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPut.');
        }

        if (requestParameters.gridJobInstanceSchema === null || requestParameters.gridJobInstanceSchema === undefined) {
            throw new runtime.RequiredError('gridJobInstanceSchema','Required parameter requestParameters.gridJobInstanceSchema was null or undefined when calling updateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/grid-job-configs/{job_id}/instances/{job_instance_id}`.replace(`{${"job_id"}}`, encodeURIComponent(String(requestParameters.jobId))).replace(`{${"job_instance_id"}}`, encodeURIComponent(String(requestParameters.jobInstanceId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GridJobInstanceSchemaToJSON(requestParameters.gridJobInstanceSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GridJobInstanceSchemaFromJSON(jsonValue));
    }

    /**
     * Update Grid Job Instances
     */
    async updateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPut(requestParameters: UpdateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GridJobInstanceSchema> {
        const response = await this.updateGridJobInstancesGridJobConfigsJobIdInstancesJobInstanceIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Stat Voy Pos Report
     */
    async updateStatVoyPosReportStatVoyPosReportsIdPutRaw(requestParameters: UpdateStatVoyPosReportStatVoyPosReportsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatVoyPosReportSchemaOutput>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateStatVoyPosReportStatVoyPosReportsIdPut.');
        }

        if (requestParameters.statVoyPosReportSchemaInput === null || requestParameters.statVoyPosReportSchemaInput === undefined) {
            throw new runtime.RequiredError('statVoyPosReportSchemaInput','Required parameter requestParameters.statVoyPosReportSchemaInput was null or undefined when calling updateStatVoyPosReportStatVoyPosReportsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/stat-voy-pos-reports/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StatVoyPosReportSchemaInputToJSON(requestParameters.statVoyPosReportSchemaInput),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatVoyPosReportSchemaOutputFromJSON(jsonValue));
    }

    /**
     * Update Stat Voy Pos Report
     */
    async updateStatVoyPosReportStatVoyPosReportsIdPut(requestParameters: UpdateStatVoyPosReportStatVoyPosReportsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatVoyPosReportSchemaOutput> {
        const response = await this.updateStatVoyPosReportStatVoyPosReportsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
